import { useCallback } from 'react'
import { createThreadMenuHandler } from './createThreadMenuHandler'

/** @param {object} m */
export function useThreadMenuAction(m) {
  const handleThreadMenuAction = useCallback(
    (thread, actionId) => createThreadMenuHandler(m)(thread, actionId),
    // eslint-disable-next-line react-hooks/exhaustive-deps -- field-level deps match prior hook
    [
      m.messagesByThreadId,
      m.navigate,
      m.urlThreadId,
      m.chatAbortRef,
      m.setActiveQueryVersionByExchangeId,
      m.setActiveAnswerVersionByExchangeId,
      m.setThreads,
      m.setMessagesByThreadId,
      m.setSelectedThreadId,
      m.setPinnedThreadIds,
      m.pinnedThreadIds,
      m.setPinLimitDialogOpen,
      m.setDismissedNoteThreadIds,
      m.setThreadShareThread,
    ],
  )
  return { handleThreadMenuAction }
}
